import { LandingSectionEyebrow } from '@/components/landing/landing-section-eyebrow'
import { LANDING_MEDIA_SECTION, LANDING_SECTION_GRADIENT } from '@/lib/landing-content'

export function LandingMediaSection() {
  return (
    <section
      id="in-the-media"
      className="py-12 md:py-32 scroll-fade-up"
      style={{ backgroundImage: LANDING_SECTION_GRADIENT }}
    >
      <div className="container mx-auto px-4 md:px-16">
        <div className="max-w-[1280px] mx-auto">
          <LandingSectionEyebrow label={LANDING_MEDIA_SECTION.eyebrow} className="mb-4" />
          <h2 className="text-3xl md:text-[48px] font-display text-gray-900 leading-[1.2] tracking-[-0.96px]">
            {LANDING_MEDIA_SECTION.titleLead}{' '}
            <span className="font-display text-brand-light">
              {LANDING_MEDIA_SECTION.titleAccent}
            </span>
          </h2>
          <p className="mt-4 text-base font-medium text-gray-500 tracking-[-0.32px] max-w-3xl">
            {LANDING_MEDIA_SECTION.description}
          </p>

          <div className="mt-8 md:mt-12 mx-auto w-full max-w-4xl">
            <div
              className="relative aspect-video w-full overflow-hidden rounded-xl"
              style={{ clipPath: 'inset(0 round 0.75rem)' }}
            >
              <iframe
                src={LANDING_MEDIA_SECTION.embedSrc}
                title={`${LANDING_MEDIA_SECTION.titleLead} ${LANDING_MEDIA_SECTION.titleAccent}`}
                className="absolute inset-0 h-full w-full rounded-xl border-0"
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
